/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { productsEndPoints } from 'api/products/constants';
import {
  TProductBEItem,
  TProductsGetListByIdsBE,
  TProductsGetListByIdsQueryParams,
} from 'api/products/products.types';
import createHttpClient from 'store/httpClient';
import { fromObjectToQueryString } from 'utils/api';

export const getProductsListByIdsAsyncThunk = createAsyncThunk<
  TProductsGetListByIdsBE['data'],
  {
    queryParams: TProductsGetListByIdsQueryParams;
    onSuccess: (data: TProductsGetListByIdsBE['data']) => void;
  }
>(
  'products/getListByIds',
  async ({ queryParams, onSuccess }, { rejectWithValue }) => {
    try {
      const httpClient = createHttpClient(undefined);

      const response = await httpClient.get<TProductsGetListByIdsBE>(
        productsEndPoints.getListByIds(fromObjectToQueryString(queryParams))
      );

      // BE for now returns only phone-case-shaped items.

      if (onSuccess) {
        onSuccess(response.data);
      }

      return response.data;
    } catch (_) {
      return rejectWithValue(null);
    }
  }
);
